/* Imports */
import React from "react"
import { Font } from "fajny-react"
import { Link } from "react-router-dom"

import ComponentPage from "../../components/ComponentPage"

const CoverPage = () => {
    const items = [
        {
            title: "Cover center",
            content: (
                <Font.P>
                    <Link to="/components/cover/demo-center" target="_blank" rel="noreferrer noopener">
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Cover src="/images/cover-parallax.jpg" alt="Cover" align="center">\n    <Font.H1 display>Title</Font.H1>\n    <Font.H2 display>Subtitle</Font.H2>\n</Cover>',
        },
        {
            title: "Cover center with overlay",
            content: (
                <Font.P>
                    <Link to="/components/cover/demo-center-overlay" target="_blank" rel="noreferrer noopener">
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Cover src="/images/cover-parallax.jpg" alt="Cover" align="center" overlay>\n    <Font.H1 display>Title</Font.H1>\n    <Font.H2 display>Subtitle</Font.H2>\n</Cover>',
        },
        {
            title: "Cover bottom",
            content: (
                <Font.P>
                    <Link to="/components/cover/demo-bottom" target="_blank" rel="noreferrer noopener">
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Cover src="/images/cover-parallax.jpg" alt="Cover" align="bottom">\n    <Font.H1 display>Title</Font.H1>\n    <Font.H2 display>Subtitle</Font.H2>\n</Cover>',
        },
        {
            title: "Cover bottom with overlay",
            content: (
                <Font.P>
                    <Link to="/components/cover/demo-bottom-overlay" target="_blank" rel="noreferrer noopener">
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<Cover src="/images/cover-parallax.jpg" alt="Cover" align="bottom" overlay>\n    <Font.H1 display>Title</Font.H1>\n    <Font.H2 display>Subtitle</Font.H2>\n</Cover>',
        },
    ]

    const propsItems = [
        {
            name: "src",
            type: "String",
            example: "/cover.jpg",
            required: "Yes",
        },
        {
            name: "alt",
            type: "String",
            example: "Cover",
            required: "Yes",
        },
        {
            name: "overlay",
            type: "Boolean",
        },
        {
            name: "align",
            type: "String",
            example: "bottom",
            possible: '"center" | "bottom"',
            default: "center",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default CoverPage
